import React, { useEffect, useState } from 'react'
import { HabilitationAccordion } from '../access/HabilitationAccordion'
import { PIEZO } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import PiezometryAction from '../../../../../../piezometry/actions/PiezometryAction'
import DtoPiezometerLight from '../../../../../../piezometry/dto/DtoPiezometerLight'

const HabilitationPiezo = ({}) => {
    const dispatch = useDispatch()
    const {
        piezometers,
    } = useSelector(store => ({
        piezometers: store.PiezometryReducer.piezometersLight,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (piezometers.length === 0) {
            dispatch(PiezometryAction.fetchPiezometersLight()).then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <HabilitationAccordion
            stationType={PIEZO}
            title={i18n.piezometry}
            stations={piezometers}
            isLoaded={isLoaded}
        />
    )
}

HabilitationPiezo.propTypes = {
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    fetchPiezometersLight: PropTypes.func,
}

export default HabilitationPiezo